export const SMOOTH_TENSION = 0.4;
export const SHARP_TENSION = 0;